var path = '/app/webpack/wealthbar/components/business_nature_options/business_nature_options.html.slim';
var html = "<select autocomplete=\"off\" ng-options=\"nature for nature in natures\"><option ng-if=\"!noSelectText\" value=\"\">Select Nature of Business</option></select>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;